<template>
  <v-form ref="form">
    <v-row>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.model') }}</v-col>
        </v-row>
        <v-text-field :value="data.model" @input="value=>updateForm('model', value)" :label="$t('formBike.model')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.id') }}</v-col>
        </v-row>
        <v-text-field :value="data.id" @input="value=>updateForm('id', value)" :label="$t('formBike.id')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.appVersion') }}</v-col>
        </v-row>
        <v-text-field :value="data.appVersion" @input="value=>updateForm('appVersion', value)" :label="$t('formBike.appVersion')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.certificate') }}</v-col>
        </v-row>
        <v-text-field :value="data.certificate" @input="value=>updateForm('certificate', value)" :label="$t('formBike.certificate')" solo="solo" flat="flat" outlined="outlined" required="required" :append-icon="mode === 'create' ? 'mdi-download' : ''"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.productionDate') }}</v-col>
        </v-row>
        <v-text-field :value="data.productionDate" @input="value=>updateForm('productionDate', value)" :label="$t('formBike.productionDate')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.maintenance') }}</v-col>
        </v-row>
        <v-text-field :value="data.maintenance" @input="value=>updateForm('maintenance', value)" :label="$t('formBike.maintenance')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
      <template v-if="mode === 'create'">
        <v-col class="pt-0 pb-0" cols="auto">
          <v-row align="center">
            <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.attachToServiceBase') }}</v-col>
          </v-row>
          <v-btn color="primary">{{ $t('formBike.CSV') }}</v-btn>
        </v-col>
      </template>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  methods: {
    updateForm (field, value) {
      this.$emit('update', { field, value })
    }
  }
}
</script>
